<template>
    <div class="mapbox" ref="mapBox"></div>
</template>
<script>
    import mapboxgl from 'mapbox-gl';
    import 'mapbox-gl/dist/mapbox-gl.css';
    export default {
        props: {
            token: {
                type: String,
                required: true
            },
            styleRoute: {
                type: String,
                required: true
            },
            latitude: {
                type: String,
                required: true
            },
            longitude: {
                type: String,
                required: true
            },
            initialZoom: {
                type: Number,
                required: false,
                default: 3
            },
            finalZoom: {
                type: Number,
                required: false,
                default: 11
            },
            speed: {
                type: Number,
                required: false,
                default: 1
            },
            pitch: {
                type: Number,
                required: false,
                default: 60
            },
            bearing: {
                type: Number,
                required: false,
                default: 0
            },
            scrollZoom: {
                type: Boolean,
                required: false,
                default: false
            },
            clickRoute: {
                type: String,
                required: false,
                default: '/'
            }
        },
        data() {
            return {
                map: null,
                coordinates: [this.longitude, this.latitude],
                marker: {
                    offset: [0, -20],
                    icon: '/assets/images/map/twyford-pin-40h.png',
                    width: '106px',
                    height: '40px'
                }
            }
        },
        mounted() {
            this.initialize();
        },
        methods: {
            initialize() {

                this.makeMap();
                this.makeMarker();

                let jQMapBox = $(this.$refs.mapBox);

                $(window).off('scroll').on('scroll', () => {

                    if (!window.ViewPort.isOnScreen(jQMapBox) || jQMapBox.hasClass('active')) {
                        return;
                    }

                    jQMapBox.addClass('active');

                    this.flyTo();
                });
            },
            flyTo() {
                this.map.flyTo({
                    bearing: this.bearing,
                    center: this.coordinates,
                    zoom: this.finalZoom,
                    speed: this.speed,
                    pitch: this.pitch
                });
            },
            makeMap() {
                mapboxgl.accessToken = this.token;

                this.map = new mapboxgl.Map({
                    container: this.$refs.mapBox,
                    style: this.styleRoute,
                    center: this.coordinates,
                    zoom: this.initialZoom,
                    scrollZoom: this.scrollZoom
                });

                this.map.addControl(new mapboxgl.NavigationControl);
            },
            makeMarker() {
                let marker = document.createElement('div');

                marker.className = 'marker';
                marker.style.backgroundImage = 'url("' + this.marker.icon + '")';
                marker.style.width = this.marker.width;
                marker.style.height = this.marker.height;

                marker.addEventListener('click', this.markerClicked);

                new mapboxgl.Marker(marker, {offset: this.marker.offset})
                    .setLngLat(this.coordinates)
                    .addTo(this.map);
            },
            markerClicked() {
                window.location.href = this.clickRoute;
            }
        }
    };
</script>


// WEBPACK FOOTER //
// resources/js/src/components/Map/MapBox.vue